import MESSAGE_ACTION from '@naruto/naruto-reducers/src/reducers/message/events';
import {
  MessageDialogObject,
  MessageConfirmObject,
  MessageSnackObject,
  SetMessageContentInitialAction,
  SetMessageDialogAction,
  SetMessageConfirmAction,
  SetMessageSnackAction,
  RemoveMessageDialogAction,
  RemoveMessageConfirmAction,
  RemoveMessageSnackAction
} from './types';

/* Initial */
export const SET_MESSAGE_INITIALIZE = (): SetMessageContentInitialAction => ({
  type: MESSAGE_ACTION.SET_MESSAGE_INITIALIZE
});

/* Dialog */
export const SET_MESSAGE_DIALOG = ({ dialog }: { dialog: MessageDialogObject }): SetMessageDialogAction => ({
  type: MESSAGE_ACTION.SET_MESSAGE_DIALOG,
  dialog
});
export const REMOVE_MESSAGE_DIALOG = (): RemoveMessageDialogAction => ({
  type: MESSAGE_ACTION.REMOVE_MESSAGE_DIALOG
});

/* Confirm */
export const SET_MESSAGE_CONFIRM = ({ confirm }: { confirm: MessageConfirmObject }): SetMessageConfirmAction => ({
  type: MESSAGE_ACTION.SET_MESSAGE_CONFIRM,
  confirm
});
export const REMOVE_MESSAGE_CONFIRM = (): RemoveMessageConfirmAction => ({
  type: MESSAGE_ACTION.REMOVE_MESSAGE_CONFIRM
});

/* Snack */
export const SET_MESSAGE_SNACK = ({ snack }: { snack: MessageSnackObject }): SetMessageSnackAction => ({
  type: MESSAGE_ACTION.SET_MESSAGE_SNACK,
  snack
});
export const REMOVE_MESSAGE_SNACK = (): RemoveMessageSnackAction => ({
  type: MESSAGE_ACTION.REMOVE_MESSAGE_SNACK
});
